import React from 'react';
import { TriangleAlertIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { PRECIO_HOY } from '../data/oferta';
export function UrgencyBar() {
  const {
    label,
    expired
  } = useCountdown(15 * 60);
  return <div className="sticky top-0 z-50 w-full bg-alarm text-white" data-id="element-106" data-mp="37u8k9adk0jcj">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-x-4 gap-y-1 px-4 py-2.5 text-center sm:flex-row sm:justify-center sm:text-left" data-id="element-107" data-mp="32vynwwg3fcpc">
        <p className="flex items-center gap-2 text-[13px] font-semibold leading-tight sm:text-sm" data-id="element-108" data-mp="2yx81pkd61fh0">
          <TriangleAlertIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-109" data-mp="2u2tyivs9i41s" />
          <span data-id="element-110" data-mp="2p5v6qjw2m96r">
            <span className="font-extrabold uppercase tracking-wide" data-id="element-111" data-mp="2p38zkld3dvp2">
              Alerta de brote escolar 2026:
            </span>{' '}
            Los piojos resistentes han llegado.
          </span>
        </p>
        <p className="flex items-center gap-2 text-[13px] font-semibold sm:text-sm" data-id="element-112" data-mp="2b5swnju08k22">
          <span className="hidden sm:inline text-white/80" data-id="element-113" data-mp="2b86nthlkdc4c">
            Oferta de lanzamiento de {PRECIO_HOY} finaliza en:
          </span>
          <span className="sm:hidden text-white/80" data-id="element-114" data-mp="1woane42nptjk">
            Oferta {PRECIO_HOY} termina en:
          </span>
          <span className="rounded bg-alarm-dark px-2 py-0.5 font-mono text-sm font-bold tabular-nums tracking-widest" role="timer" aria-live="off" data-id="element-115" data-mp="1i0fvur0dxv82">
            {expired ? '00:00:00' : label}
          </span>
        </p>
      </div>
    </div>;
}